import { combineReducers } from '@reduxjs/toolkit';
import { connectRouter } from 'connected-react-router';
import { History, LocationState } from 'history';
import { articleApi } from '../../features/article/api/articleApi';
import { categoryApi } from '../../features/category/api/categoryApi';
import { commonSlice } from '../../shared/redux/commonSlice';
import { authApi } from '../auth/api/authApi';

export const rootReducer = (history: History<LocationState>) =>
  combineReducers({
    router: connectRouter(history),
    [commonSlice.name]: commonSlice.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [articleApi.reducerPath]: articleApi.reducer,
  });
